import { render, staticRenderFns } from "./wechatServerForm.vue?vue&type=template&id=3d68a05a&scoped=true"
import script from "./wechatServerForm.vue?vue&type=script&lang=js"
export * from "./wechatServerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68a05a",
  null
  
)

export default component.exports